/* Señales y cuotas de la ficha: sincronizar con la variante elegida.

   Todo lo que se ve lo arma Liquid. Lo unico que falta resolver es que el aviso de stock y el
   monto de la cuota cambian segun el talle elegido, y Horizon no vuelve a renderizar la
   columna entera al cambiar de variante: dispara `variant:update` con el HTML nuevo de la
   seccion adentro del evento, y cada pieza se actualiza sola. Es el mismo contrato que usa
   assets/product-inventory.js del tema, asi que hay un solo camino en vez de dos.

   Por que hay tan poco aca:
   - El numero de "personas viendo" lo calcula Liquid con el reloj de la tienda. No hay
     Math.random ni sessionStorage: el original sortea el numero en cada carga y el visitante
     con dos pestañas abiertas ve dos numeros distintos.
   - Los puntitos laten con CSS y la barra de beneficios rota con CSS. Cero intervalos: no hay
     nada que limpiar ni nada corriendo con la pestaña oculta.
   - No se consulta ninguna API. El stock ya viene resuelto en el HTML que manda el evento.

   Dos detalles que hay que respetar al tocar esto:
   1. El nodo existe en el DOM aunque no muestre nada (atributo `hidden`). Si no existiera, no
      habria a quien avisarle del cambio de variante y el aviso de "ultima unidad" no
      aparecería nunca al elegir el talle que esta por agotarse. Por eso `hidden` se
      sincroniza a mano: morph con childrenOnly toca los hijos, no los atributos del host.
   2. La busqueda en el HTML nuevo va por data-fp-bloque (el id del bloque, estable entre
      renders). Con querySelector por etiqueta, dos bloques iguales en la misma ficha se
      copiarian el contenido uno al otro. */

import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class FpPiezaDeVariante extends HTMLElement {
  #contenedor = null;

  connectedCallback() {
    // La ficha puede estar en la pagina o dentro del dialogo de agregado rapido; el evento
    // viaja hasta el contenedor de cada uno, no mas arriba.
    this.#contenedor = this.closest('.shopify-section, dialog');
    this.#contenedor?.addEventListener(ThemeEvents.variantUpdate, this.#alCambiarVariante);
  }

  disconnectedCallback() {
    this.#contenedor?.removeEventListener(ThemeEvents.variantUpdate, this.#alCambiarVariante);
    this.#contenedor = null;
  }

  #alCambiarVariante = (evento) => {
    const datos = evento.detail?.data;
    if (!datos?.html) return;

    // Listado combinado: el producto cambio entero, hay que seguirlo.
    if (datos.newProduct) {
      this.dataset.fpProducto = datos.newProduct.id;
    } else if (datos.productId && this.dataset.fpProducto && datos.productId !== this.dataset.fpProducto) {
      // Evento de OTRO producto de la misma pagina (un destacado, por ejemplo).
      return;
    }

    const id = this.dataset.fpBloque;
    const nuevo =
      (id && datos.html.querySelector(`${this.localName}[data-fp-bloque="${id}"]`)) ||
      datos.html.querySelector(this.localName);

    if (!nuevo) return;

    morph(this, nuevo, { childrenOnly: true });

    // El host no lo toca morph: sin esto, el bloque que arranco vacio se quedaria oculto para
    // siempre (y el que arranco con contenido dejaria un hueco al vaciarse).
    this.hidden = nuevo.hasAttribute('hidden');
  };
}

for (const etiqueta of ['fp-product-signals', 'fp-product-cuotas', 'fp-product-ahorro']) {
  if (!customElements.get(etiqueta)) {
    customElements.define(etiqueta, class extends FpPiezaDeVariante {});
  }
}
